import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DriverMetricDto } from '@fleet-beat/api';
import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  Environment,
  GetManyDto,
  PageableListDto,
  ResponseDto,
} from '@fleet-beat/core';
import { Observable, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DriverMetricsApiService {
  private readonly baseUrl: string = `${this.environment.metricsApiUrl}/api/driverMetrics`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  getMany(params: GetManyDto, auth: AuthHeaders): Observable<PageableListDto<DriverMetricDto>> {
    return this.baseApiService.get(this.baseUrl, { auth, params }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<PageableListDto<DriverMetricDto>>) => this.baseApiService.mapResponse(response)),
    );
  }
}
